/* FORMÉ v2 — small, dependency-free behaviours for the forme-* sections. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------------- Product page ---------------- */

  function FormeProduct(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-fx-product-json]');
    if (!dataEl) return;
    this.data = JSON.parse(dataEl.textContent);
    this.form = root.querySelector('form[action*="/cart/add"]');
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.qtyInput = this.form ? this.form.querySelector('input[name="quantity"]') : null;
    this.atc = root.querySelector('[data-fx-atc]');
    this.atcLabel = root.querySelector('[data-fx-atc-label]');
    this.track = root.querySelector('[data-fx-track]');
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fx-thumb]'));
    this.counter = root.querySelector('[data-fx-count]');
    this.slides = this.track ? Array.prototype.slice.call(this.track.children) : [];

    var self = this;
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-fx-option]')) self.onOptionChange();
      if (e.target.matches('[data-fx-tier]')) self.onTierChange();
    });

    this.thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { self.goTo(parseInt(btn.dataset.fxThumb, 10)); });
    });
    root.querySelectorAll('[data-fx-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.goTo(self.current() + (btn.dataset.fxNav === 'next' ? 1 : -1));
      });
    });
    if (this.track) {
      var t;
      this.track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { self.syncThumbs(self.current(), true); }, 80);
      }, { passive: true });
    }

    this.sticky = root.querySelector('[data-fx-sticky]');
    if (this.sticky && this.atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        self.sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(this.atc);
      this.sticky.querySelector('[data-fx-sticky-btn]').addEventListener('click', function () {
        if (self.atc.disabled) self.atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else self.atc.click();
      });
    }

    var start = parseInt(root.dataset.fxStart || '0', 10);
    if (start > 0) this.goTo(start, true);
    this.onOptionChange(true);
    if (this.qty() > 1) this.onTierChange();

    // make sure a single-item add never carries leftover bundle lines (and a bundle add is current)
    if (this.form) {
      this.form.addEventListener('submit', function () {
        if (self.bundleOn) self.updateBundle(true);
        else self.clearBundleForm();
      }, true);
    }
  }

  FormeProduct.prototype.current = function () {
    if (!this.track || !this.track.clientWidth) return 0;
    return Math.round(this.track.scrollLeft / this.track.clientWidth);
  };

  FormeProduct.prototype.goTo = function (index, instant) {
    if (!this.track || !this.slides.length) return;
    index = Math.max(0, Math.min(this.slides.length - 1, index));
    var track = this.track;
    var target = index * track.clientWidth;
    track.scrollTo({ left: target, behavior: instant ? 'auto' : 'smooth' });
    // safety net for browsers/tabs where smooth scrolling doesn't run (e.g. background tabs)
    if (!instant) setTimeout(function () { if (Math.abs(track.scrollLeft - target) > 2) track.scrollLeft = target; }, 700);
    this.syncThumbs(index, !!instant);
  };

  FormeProduct.prototype.syncThumbs = function (index, moveColumn) {
    this.thumbs.forEach(function (b) {
      var on = parseInt(b.dataset.fxThumb, 10) === index;
      b.setAttribute('aria-current', on ? 'true' : 'false');
      if (on && moveColumn && b.parentElement.scrollHeight > b.parentElement.clientHeight) {
        // only once the gallery has settled: scrolling another element mid-way cancels its smooth scroll in Chrome
        b.parentElement.scrollTop = b.offsetTop - b.parentElement.clientHeight / 2 + b.clientHeight / 2;
      }
    });
    if (this.counter) this.counter.textContent = index + 1 + ' / ' + this.slides.length;
  };

  FormeProduct.prototype.selectedOptions = function () {
    var opts = [];
    this.root.querySelectorAll('[data-fx-option-group]').forEach(function (group) {
      var checked = group.querySelector('[data-fx-option]:checked');
      opts[parseInt(group.dataset.fxOptionGroup, 10)] = checked ? checked.value : null;
    });
    return opts;
  };

  FormeProduct.prototype.findVariant = function (opts) {
    return this.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
    });
  };

  FormeProduct.prototype.onOptionChange = function (initial) {
    var opts = this.selectedOptions();
    var variant = this.findVariant(opts);
    this.variant = variant;
    var self = this;

    // selected value labels
    this.root.querySelectorAll('[data-fx-option-group]').forEach(function (group) {
      var i = parseInt(group.dataset.fxOptionGroup, 10);
      var out = group.querySelector('[data-fx-option-value]');
      if (out) out.textContent = opts[i] || '';
    });

    // availability of values given the other selections
    this.root.querySelectorAll('[data-fx-option-group]').forEach(function (group) {
      var i = parseInt(group.dataset.fxOptionGroup, 10);
      group.querySelectorAll('[data-fx-option]').forEach(function (input) {
        var trial = opts.slice();
        trial[i] = input.value;
        var match = self.findVariant(trial);
        var label = input.closest('label');
        var unavailable = !match || !match.available;
        if (label) label.classList.toggle('is-unavailable', unavailable);
      });
    });

    if (variant && this.idInput) {
      this.idInput.value = variant.id;
      this.idInput.disabled = false;
    }

    this.renderPrices();

    if (!initial && variant) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // jump gallery to the colour image
    if (!initial && this.data.colorIndex > -1) {
      var colour = opts[this.data.colorIndex];
      var mediaId = this.data.colorMedia[colour] || (variant && variant.media);
      var slideIndex = this.data.mediaIndex[mediaId];
      if (slideIndex !== undefined) this.goTo(slideIndex);
    }
  };

  FormeProduct.prototype.qty = function () {
    var tier = this.root.querySelector('[data-fx-tier]:checked');
    return tier ? parseInt(tier.value, 10) || 1 : 1;
  };

  FormeProduct.prototype.onTierChange = function () {
    var q = this.qty();
    if (this.qtyInput) this.qtyInput.value = q;
    this.syncBundle(q);
    this.renderPrices();
  };

  /* Bundle: one colour + size picker per item when a tier of 2+ is chosen.
     Items are handed to product-form.js through quantity-breaks-<section>.formVariants,
     which it posts to /cart/add as separate line items. */
  FormeProduct.prototype.syncBundle = function (q) {
    var box = this.root.querySelector('[data-fx-bundle]');
    var rowsEl = this.root.querySelector('[data-fx-bundle-rows]');
    var on = q > 1 && !!box && !!rowsEl && (this.data.optionValues || []).length > 0;
    this.bundleOn = on;
    if (box) box.hidden = !on;
    this.root.querySelectorAll('[data-fx-option-group]').forEach(function (g) { g.hidden = on; });
    var dyn = this.root.querySelector('.fx-buy__dynamic');
    if (dyn) dyn.hidden = on;
    if (!on) { this.clearBundleForm(); return; }
    var defaults = this.selectedOptions();
    while (rowsEl.children.length < q) rowsEl.appendChild(this.buildRow(rowsEl.children.length, defaults));
    while (rowsEl.children.length > q) rowsEl.removeChild(rowsEl.lastChild);
    this.updateBundle(true);
  };

  FormeProduct.prototype.buildRow = function (i, defaults) {
    var self = this;
    var d = this.data;
    var label = (d.strings.item || 'Item') + ' ' + (i + 1);
    var uid = (this.root.dataset.fxUid = this.root.dataset.fxUid || String(Math.random()).slice(2, 8));
    var row = document.createElement('div');
    row.className = 'fx-brow';

    var head = document.createElement('div');
    head.className = 'fx-brow__head';
    var num = document.createElement('span');
    num.className = 'fx-brow__n';
    num.textContent = label;
    var choice = document.createElement('span');
    choice.className = 'fx-brow__choice';
    head.appendChild(num);
    head.appendChild(choice);
    row.appendChild(head);

    d.optionValues.forEach(function (values, oi) {
      var isColor = oi === d.colorIndex;
      var group = document.createElement('div');
      group.className = isColor ? 'fx-brow__swatches' : 'fx-brow__sizes';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', label + ' ' + ((d.optionNames || [])[oi] || ''));
      values.forEach(function (val) {
        var lab = document.createElement('label');
        lab.className = isColor ? 'fx-bsw' : 'fx-bsz';
        lab.title = val;
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'fx-b' + uid + '-' + i + '-' + oi;
        input.value = val;
        input.dataset.fxBopt = oi;
        if (defaults[oi] === val) input.checked = true;
        input.addEventListener('change', function () { self.updateBundle(); });
        lab.appendChild(input);
        var face = document.createElement('span');
        if (isColor) {
          face.className = 'fx-bsw__img';
          var src = d.colorImages ? d.colorImages[val] : '';
          if (src) {
            var img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.loading = 'lazy';
            face.appendChild(img);
          }
          var sr = document.createElement('span');
          sr.className = 'visually-hidden';
          sr.textContent = val;
          lab.appendChild(face);
          lab.appendChild(sr);
        } else {
          face.textContent = val;
          lab.appendChild(face);
        }
        group.appendChild(lab);
      });
      row.appendChild(group);
    });
    return row;
  };

  FormeProduct.prototype.rowOptions = function (row) {
    var opts = [];
    (this.data.optionValues || []).forEach(function (values, oi) {
      var checked = row.querySelector('input[data-fx-bopt="' + oi + '"]:checked');
      opts[oi] = checked ? checked.value : values[0];
    });
    return opts;
  };

  FormeProduct.prototype.updateBundle = function (skipRender) {
    var self = this;
    var d = this.data;
    var items = {};
    var order = [];
    this.bundleVariants = [];
    this.root.querySelectorAll('.fx-brow').forEach(function (row) {
      var opts = self.rowOptions(row);
      var v = self.findVariant(opts);
      row.querySelectorAll('input[data-fx-bopt]').forEach(function (input) {
        var oi = parseInt(input.dataset.fxBopt, 10);
        var trial = opts.slice();
        trial[oi] = input.value;
        var m = self.findVariant(trial);
        input.parentNode.classList.toggle('is-unavailable', !m || !m.available);
      });
      var choice = row.querySelector('.fx-brow__choice');
      if (choice) choice.textContent = opts.join(' · ') + (!v || !v.available ? ' — ' + d.strings.soldOut : '');
      row.classList.toggle('is-unavailable', !v || !v.available);
      self.bundleVariants.push(v || null);
      if (v) {
        if (!items[v.id]) { items[v.id] = { id: v.id, quantity: 0 }; order.push(v.id); }
        items[v.id].quantity += 1;
      }
    });
    var breaks = this.root.querySelector('[id^="quantity-breaks-"]');
    if (breaks) breaks.formVariants = order.map(function (id) { return items[id]; });
    if (!skipRender) this.renderPrices();
  };

  FormeProduct.prototype.clearBundleForm = function () {
    var breaks = this.root.querySelector('[id^="quantity-breaks-"]');
    if (breaks) breaks.formVariants = [];
    var holder = this.form && this.form.querySelector('.product-form__variants');
    if (holder) holder.innerHTML = '';
    this.bundleVariants = null;
  };

  FormeProduct.prototype.renderPrices = function () {
    var fmt = this.data.moneyFormat;
    var v = this.variant;
    var price = v ? v.price : 0;
    var self = this;

    var priceEl = this.root.querySelector('[data-fx-price]');
    if (priceEl && v) {
      priceEl.innerHTML = '<span>' + formatMoney(price, fmt) + '</span>' +
        (v.compare > price ? ' <s>' + formatMoney(v.compare, fmt) + '</s>' : '');
    }

    var selectedTotal = price;
    this.root.querySelectorAll('[data-fx-tier]').forEach(function (input) {
      var q = parseInt(input.value, 10) || 1;
      var pct = parseFloat(input.dataset.fxPct || '0') || 0;
      var full = price * q;
      var total = Math.round(full * (100 - pct) / 100);
      var box = input.closest('label');
      var set = function (sel, text) { var el = box.querySelector(sel); if (el) el.textContent = text; };
      set('[data-fx-tier-total]', formatMoney(total, fmt));
      set('[data-fx-tier-each]', formatMoney(Math.round(total / q), fmt) + ' ' + (self.data.strings.each || 'each'));
      set('[data-fx-tier-save]', full - total > 0 ? (self.data.strings.save || 'Save') + ' ' + formatMoney(full - total, fmt) : '');
      if (input.checked) selectedTotal = total;
    });

    if (this.qtyInput) this.qtyInput.value = this.qty();

    var bundle = this.bundleOn && this.bundleVariants;
    var bundleOk = true;
    if (bundle) {
      var checkedTier = this.root.querySelector('[data-fx-tier]:checked');
      var bp = checkedTier ? parseFloat(checkedTier.dataset.fxPct || '0') || 0 : 0;
      var sum = 0;
      this.bundleVariants.forEach(function (bv) {
        if (!bv || !bv.available) bundleOk = false;
        sum += bv ? bv.price : 0;
      });
      selectedTotal = Math.round(sum * (100 - bp) / 100);
    }

    if (this.sticky) {
      var sv = this.sticky.querySelector('[data-fx-sticky-var]');
      var sb = this.sticky.querySelector('[data-fx-sticky-btn]');
      if (sv) {
        sv.textContent = bundle
          ? this.bundleVariants.length + ' ' + (this.data.strings.briefs || 'items') + ' \u00B7 ' + formatMoney(selectedTotal, fmt)
          : (v ? v.options.join(' / ') + ' \u00B7 ' : '') + formatMoney(selectedTotal, fmt);
      }
      if (sb) sb.disabled = bundle ? !bundleOk : !v || !v.available;
    }

    if (this.atc && this.atcLabel && bundle) {
      this.atc.disabled = !bundleOk;
      this.atcLabel.textContent = bundleOk
        ? this.data.strings.addToCart + ' \u00B7 ' + formatMoney(selectedTotal, fmt)
        : this.data.strings.soldOut;
    } else if (this.atc && this.atcLabel) {
      if (!v) {
        this.atc.disabled = true;
        this.atcLabel.textContent = this.data.strings.unavailable;
      } else if (!v.available) {
        this.atc.disabled = true;
        this.atcLabel.textContent = this.data.strings.soldOut;
      } else {
        this.atc.disabled = false;
        this.atcLabel.textContent = this.data.strings.addToCart + ' · ' + formatMoney(selectedTotal, fmt);
      }
    }
  };

  /* ---------------- Tabs ---------------- */

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  /* ---------------- Unit toggle ---------------- */

  function initUnits(root) {
    var buttons = root.querySelectorAll('[data-fx-unit-btn]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var inches = btn.dataset.fxUnitBtn === 'in';
        root.classList.toggle('fx-units-in', inches);
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });
  }

  /* ---------------- Reviews: filter + pages ---------------- */

  function initReviews(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fx-review]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-fx-chip]'));
    var pager = root.querySelector('[data-fx-pages]');
    var perPage = parseInt(root.dataset.fxPerPage || '3', 10);
    var filter = null;
    var page = 0;

    function render() {
      var matches = cards.filter(function (c) {
        if (!filter) return true;
        return (c.dataset.fxTags || '').toLowerCase().indexOf(filter) > -1 ||
          c.textContent.toLowerCase().indexOf(filter) > -1;
      });
      var pages = Math.max(1, Math.ceil(matches.length / perPage));
      if (page >= pages) page = 0;
      cards.forEach(function (c) { c.hidden = true; });
      matches.slice(page * perPage, page * perPage + perPage).forEach(function (c) { c.hidden = false; });
      if (pager) {
        pager.innerHTML = '';
        if (pages > 1) {
          for (var i = 0; i < pages; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = i + 1;
            b.setAttribute('aria-current', i === page ? 'true' : 'false');
            b.setAttribute('aria-label', 'Page ' + (i + 1));
            (function (n) { b.addEventListener('click', function () { page = n; render(); }); })(i);
            pager.appendChild(b);
          }
        }
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var value = chip.dataset.fxChip.toLowerCase();
        filter = filter === value ? null : value;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', filter && c === chip ? 'true' : 'false'); });
        page = 0;
        render();
      });
    });
    render();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-fx-product]').forEach(function (el) {
      if (!el.__fx) el.__fx = new FormeProduct(el);
    });
    scope.querySelectorAll('[data-fx-tabs]').forEach(function (el) {
      if (!el.__fx) { el.__fx = true; initTabs(el); }
    });
    scope.querySelectorAll('[data-fx-units]').forEach(function (el) {
      if (!el.__fx) { el.__fx = true; initUnits(el); }
    });
    scope.querySelectorAll('[data-fx-reviews]').forEach(function (el) {
      if (!el.__fx) { el.__fx = true; initReviews(el); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
